import s from "./ventory.module.css"
import { BsTwitter } from "react-icons/bs"
import { FcLike } from "react-icons/fc"
import { BiTrendingDown, BiTrendingUp } from "react-icons/bi"
import { IconContext } from "react-icons";
import { hypeLevel, pageColor } from "../../../helper/helper";
import imgNotFound from "../../../assets/eagleShadow.png"
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LIKE_PROJECT } from "../../../Redux/actions/actions";
import * as React from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SimpleDialog from "../../Login/dialogLogin/DialogLogin";

export default function VentoryProjectInfo({colorFondo, project, i }) {
    const [hovered, setHovered] = useState(false);
    const dispatch = useDispatch()

    let estilo = pageColor(colorFondo)
    function handleimgError({ currentTarget }) {
        currentTarget.onerror = null;
        currentTarget.src = imgNotFound
    }

    return (
        <div className={s.row}>
            <div className={s.number}><div className={s.indice}>{i + 1}</div></div>
            <div className={s.imgContainer}><img width={"100"} height={"100"} src={project.img === "nothing" ? imgNotFound : project.img} onError={(e) => handleimgError(e)} alt={project.name} /></div>
            <div className={s.name}>{project.name}</div>
            <div className={s.name}>{project.floorPrice}</div>
            <div className={s.name} style= {project.floorChange[0] == "-" ?  {color:"red"} :  {color:"green"}}>
                {project.floorChange }
                {project.floorChange[0] === "-" ? <BiTrendingDown color="red"/> : <BiTrendingUp color="green"/>}
            </div>
            <div className={s.name}>{project.volume} VENOM</div>
            <div className={s.name} style= {project.volumeChange[0] == "-" ?  {color:"red"} :  {color:"green"}}>
                {project.volumeChange}
            {project.volumeChange[0] === "-" ? <BiTrendingDown color="red"/> : <BiTrendingUp color="green"/>}
            </div>
            <div className={s.name}>{project.owners}</div>
            <div className={s.name}>{project.items}</div>
        </div>

    )
}